// extracted by mini-css-extract-plugin
export default {"tableLayoutFixed":"DiffLines-module__tableLayoutFixed--YZcIJ","compact":"DiffLines-module__compact--wEEom"};